import React, { useEffect, useState } from 'react';
import { FilterListItem } from '../CheckboxList';
import { FieldValues, Path } from 'react-hook-form';
import { useCurrentApp } from '../../../context/CurrentApp';
import FilterDependencyMessage from '../../Filters/FilterDependencyMessage';
import { translate } from '../../../services/translate';
import RadioList from '../RadioList';
import { accessService } from '../../../services/central-api/access';

function InternetCompanyList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name, companyId }: { name: TName; companyId?: number | null; }) {
    const { isParentApp } = useCurrentApp();
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getItems() {
        try {
            setIsLoading(true);
            const items = await accessService.getInternetCompaniesSimplified(isParentApp && companyId ? companyId : undefined);
            setItems(items.filter(item => !item.deletedAt).map(item => ({ label: item.name, value: item.id })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (isParentApp && !companyId) {
            return;
        }
        getItems();
    }, [companyId]);

    if (isParentApp && !companyId) {
        return <FilterDependencyMessage message={translate('selectCompanyFirst')} />;
    }

    return <RadioList items={items} name={name} clearValue={null} isLoading={isLoading} />;
}

InternetCompanyList.getCount = RadioList.getCount;

export default InternetCompanyList;
